import { QuickNotesIcon } from '@hakimo-ui/hakimo/ui-elements';
import { Button } from '@hakimo-ui/shared/ui-base';
import clsx from 'clsx';
import { useState } from 'react';
import { LocationNotesModal } from './LocationNotesModal';
import { getZeroToleranceTextColor } from '../sop-workflow/utils';

interface Props {
  locationId: string;
  isZeroToleranceSite?: boolean;
}

export function LocationNotes({ locationId, isZeroToleranceSite }: Props) {
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
  const handleOpenNotesModal = () => {
    setIsNotesModalOpen(true);
  };
  const handleCloseNotesModal = () => {
    setIsNotesModalOpen(false);
  };
  return (
    <div>
      <Button
        variant="icon"
        onClick={handleOpenNotesModal}
        title="Quick Notes"
        className={clsx(isZeroToleranceSite && 'hover:!bg-white/20')}
      >
        <QuickNotesIcon
          className={clsx(
            'h-5 w-5 stroke-2',
            getZeroToleranceTextColor(isZeroToleranceSite)
          )}
        />
      </Button>
      <LocationNotesModal
        isOpen={isNotesModalOpen}
        onClose={handleCloseNotesModal}
        locationId={locationId}
      />
    </div>
  );
}
